<template>
  <el-container class="branch-notQualified-analysis pagination-list">
    <el-main>
      <div class="content">
        <el-col :span="22" class="branch-notQualified-analysis-search">
          <el-form>
            <el-form-item label="起始时间:" label-width="80px">
              <el-date-picker v-model="searchParams.startTime" value-format="yyyy-MM-dd" type="month"></el-date-picker>
            </el-form-item>

            <el-form-item label="终止时间:" label-width="80px">
              <el-date-picker v-model="searchParams.endTime" value-format="yyyy-MM-dd" type="month"></el-date-picker>
            </el-form-item>

            <el-form-item label="所属分公司" label-width="80px">
              <el-input :title="filiale" v-model="filiale" placeholder="请选择分公司" readonly @click.native.prevent="openDialog"></el-input>
            </el-form-item>

            <el-form-item>
              <el-button @click="search" size="mini">生成</el-button>
            </el-form-item>
          </el-form>
        </el-col>
        <div class="echarts-bar-line" ref="echartsBarLine"></div>
        <select-filiale-dialog
          :dialogVisible="dialogVisible"
          @setFiliale="setFiliale"
          @setSelectList="setSelectList"
          @closeDialog="closeDialog"></select-filiale-dialog>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import moment from 'moment'
import Vue from 'vue'
import _ from 'lodash'
import SelectFilialeDialog from './publicDialog/select-filiale-dialog.vue'
let echarts = require('echarts/lib/echarts')
require('echarts/lib/chart/line')
require('echarts/lib/component/tooltip')
Vue.use(echarts)

export default {
  name: 'branch-notQualified-analysis',
  components: {SelectFilialeDialog},
  data () {
    return {
      dialogVisible: false,
      // 已选分公司
      selectList: [],
      searchParams: {
        startTime: moment().subtract(1, 'months').format('YYYY-MM-01'),
        endTime: moment().format('YYYY-MM-01')
      },
      filiale: ''
    }
  },
  mounted () {
    this.drawEcharts()
    // 监听窗口大小变化重绘echarts
    window.onresize = _.debounce(() => {
      let myCharts = echarts.init(this.$refs.echartsBarLine)
      myCharts.resize()
    }, 100)
  },
  methods: {
    drawEcharts () {
      let myCharts = echarts.init(this.$refs.echartsBarLine)
      myCharts.setOption({
        title: {
          text: '当月未达标经销商分析',
          textStyle: {
            color: '#2A2929',
            fontSize: 20
          }
        },
        grid: {
          bottom: 50
        },
        xAxis: {
          type: 'category'
        },
        yAxis: {
          minInterval: 1
        }
      })
    },
    openDialog () {
      this.dialogVisible = true
    },
    // 当前选中分公司
    setFiliale (filiale) {
      this.filiale = filiale
    },
    setSelectList (selectList) {
      this.selectList = selectList
      this.dialogVisible = false
    },
    closeDialog () {
      this.dialogVisible = false
    },
    // 按日期排序从后端获得的数据
    formatterData (data) {
      let orderData = {}
      Object.keys(data).reverse().forEach(key => {
        orderData[key] = data[key]
      })
      return orderData
    },
    search () {
      if (!this.searchParams.startTime) {
        return this.$message.error('请选择起始时间')
      }
      if (!this.searchParams.endTime) {
        return this.$message.error('请选择终止时间')
      }
      if (new Date(this.searchParams.startTime).getTime() > new Date(this.searchParams.endTime).getTime()) {
        return this.$message.error('起始时间不能大于终止时间')
      }
      if (this.selectList.length === 0) {
        return this.$message.error('请选择分公司')
      }
      let data = {
        startTime: this.searchParams.startTime,
        endTime: this.searchParams.endTime,
        deptIds: this.selectList.map(e => e.id)
      }
      let myCharts = echarts.init(this.$refs.echartsBarLine)
      myCharts.showLoading({
        text: '加载中...',
        color: '#47A2FF',
        textColor: '#47A2FF',
        maskColor: 'rgba(255, 255, 255, 0.8)',
        zlevel: 0
      })
      this.$axios.post('/huaao-api/visualReport/notQualified', data).then(res => {
        let saleData = {}
        let xAxisData = []
        let series = []
        // 设置x轴数据
        Object.keys(res.data).forEach(key => {
          // 将id转换成对应公司名
          let keyName = this.selectList.find(item => item.id === key).name
          saleData[keyName] = res.data[key]
          // 设置x轴数据，用其中任意一个公司的数据即可，只需操作一次
          if (xAxisData.length === 0) {
            Object.keys(res.data[key]).reverse().forEach(month => {
              xAxisData.push(month)
            })
          }
        })
        // 设置柱状图数据
        Object.keys(saleData).forEach(key => {
          // 后端回传的日期是从大到小，这里调换一下数据顺序
          saleData[key] = this.formatterData(saleData[key])
          for (let i in saleData[key]) {
            // 无值的全部赋值为0
            if (!saleData[key][i]) {
              saleData[key][i] = {}
              saleData[key][i]['other'] = 0
              saleData[key][i]['lessThan11'] = 0
            }
          }
          let currentLineData = Object.values(saleData[key])
          let lessThan11 = [] // 小于11的分公司
          let other = []
          currentLineData.forEach(item => {
            lessThan11.push(item.lessThan11)
            other.push(item.other)
          })
          series.push(
            {
              name: key + '橙色店数',
              type: 'bar',
              data: lessThan11,
              stack: key,
              label: {
                show: !!lessThan11.find(item => item !== 0)
              },
              itemStyle: {
                color: '#ED7D31'
              }
            }, {
              name: key + '正常合作',
              type: 'bar',
              data: other,
              stack: key,
              label: {
                show: !!other.find(item => item !== 0)
              },
              itemStyle: {
                color: '#4472C4'
              }
            })
        })
        myCharts.clear()
        myCharts.setOption({
          title: {
            text: '当月未达标经销商分析',
            textStyle: {
              color: '#2A2929',
              fontSize: 20
            }
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow',
              snap: 'true'
            },
            confine: true,
            formatter: function (params) {
              let html = `<div>${params[0].name}<br>`
              params.forEach((item, i) => {
                if (i % 2 === 0) {
                  html += `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#ED7D31;"></span>&nbsp;<span style="display: inline-block;width: 200px;"> ${item.seriesName}: ${item.value}</span> &nbsp;&nbsp;`
                } else {
                  html += `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#4472C4;"></span>&nbsp;<span style="display: inline-block;width: 200px;"> ${item.seriesName}: ${item.value}</span> <br>`
                }
              })
              html += '</div>'
              return html
            }
          },
          grid: {
            bottom: 50
          },
          yAxis: {
            minInterval: 1
          },
          xAxis: {
            type: 'category',
            data: xAxisData
          },
          series: series
        }, true)
        myCharts.hideLoading()
      }).catch(() => {
        myCharts.hideLoading()
      })
    }
  }
}
</script>

<style lang="scss">
  @import "@/assets/scss/common.scss";

  .el-container.branch-notQualified-analysis {
    .content {
      height: calc(100% - 80px);

      .branch-notQualified-analysis-search {
        .el-form {
          display: flex;
          flex-wrap: nowrap;
          overflow-x: scroll;
          height: 46px;
          .el-form-item{
             flex: 0 1 auto;
           }
          .el-form-item:nth-of-type(4){
            margin-left: 10px;
          }
          .el-form-item:last-of-type{
            margin-left: 50px;
          }
        }
        .el-button{
          padding: 4px 10px;
          border-color: #55ACF1;
          color: #55ACF1;
          span{
            font-size: 12px;
          }
        }
      }
      .echarts-bar-line{
        width: 92%;
        height: 92%;
        min-width: 800px;
        min-height: 600px;
        margin: 50px auto 0;
      }
      .select-filiale{
        .dialog-content {
          height: 500px;
          overflow: auto;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/custom/page/huaao/visualReport/branch-notQualified-analysis.vue